import { ReactNode, useCallback, useMemo } from 'react';
import {
  RoutineLabelPickerContext,
  RoutineLabelPickerRequest,
} from './routineLabelPickerContext';

type Props = {
  onRequestChange: (request: RoutineLabelPickerRequest | null) => void;
  children: ReactNode;
};

// The picker is hosted as a sibling slide panel owned by the routine-submit
// route component. Opening/closing is driven purely by whether a request is
// set: the host registers a conditional column, and SlideLayout auto-reveals
// it when it goes null -> defined and auto-closes it on defined -> null.
export const RoutineLabelPickerProvider = ({
  onRequestChange,
  children,
}: Props) => {
  const openLabelPicker = useCallback(
    (request: RoutineLabelPickerRequest) => {
      onRequestChange(request);
    },
    [onRequestChange]
  );

  const closeLabelPicker = useCallback(() => {
    onRequestChange(null);
  }, [onRequestChange]);

  const value = useMemo(
    () => ({ openLabelPicker, closeLabelPicker }),
    [openLabelPicker, closeLabelPicker]
  );

  return (
    <RoutineLabelPickerContext.Provider value={value}>
      {children}
    </RoutineLabelPickerContext.Provider>
  );
};
